import(/* webpackMode: "eager" */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/freelancer-workflow/page.jsx");
